<template>
  <div>
    <el-select class="filter__input" size="mini" v-model="localValue" filterable placeholder="请选择" @change="$emit('input', $event)">
      <el-option :label="item.label" :value="item.value" v-for="(item, index) in localLists" :key="index"></el-option>
    </el-select>
  </div>
</template>
<script>
import {aderLists} from '../../api/api'
export default {
  props: {
    value: { // v-model 必须使用value名字
      required: true, // 必须传递该属性
      default: '' // 未传值时的默认值
    },
    lists: {
      type: Array, // 必须为字符串
      default: () => []
    }
  },
  data () {
    return {
      localValue: this.value,
      localLists: this.lists
    }
  },
  methods: {
    getLists () {
      let params = {
        l: 1000,
        p: 1
      }
      aderLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.localLists = data.d.lists.map((item, index) => {
            return {
              label: item.name + '(' + item.arid + ')',
              value: item.arid,
              name: item.name + '(' + item.arid + ')',
              arid: item.arid
            }
          })
          this.localLists.unshift({
            label: '所有',
            value: '',
            name: '所有',
            arid: ''
          })
          this.$emit('update:lists', this.localLists)
        }
      })
    }
  },
  mounted () {
    this.getLists()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/data-select/aderSelect.vue